// src/DatabaseAdmin/Modal.jsx
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { getAPIUrl } from '../api/apiUtils';
import styles from './Modal.module.scss';

const API_BASE_URL = getAPIUrl();

const Modal = ({ isOpen, onClose, selectedTable, newRow, setNewRow, onSave, error }) => {
  const [regions, setRegions] = useState([]);

  // Загружаем список регионов для выпадающего списка
  useEffect(() => {
    if (isOpen && selectedTable === 'Паблики') {
      const fetchRegions = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/crud/table/region?per_page=1000`);
          setRegions(response.data.data || []);
        } catch (error) {
          console.error('Ошибка загрузки регионов:', error);
        }
      };
      fetchRegions();
    }
  }, [isOpen, selectedTable]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay_DatabaseAdmin}>
      <div className={styles.modal_DatabaseAdmin}>
        <div className={styles.header_DatabaseAdmin}>
          <h5 className={styles.title_DatabaseAdmin}>{newRow.id ? 'Редактирование' : 'Новая запись'}</h5>
          <button className={styles.closeButton_DatabaseAdmin} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.content_DatabaseAdmin}>
          {error && <div className={styles.error_DatabaseAdmin}>{error}</div>}
          {selectedTable === 'Регионы' ? (
            <>
              <input
                className={styles.input_DatabaseAdmin}
                value={newRow.city || ''}
                onChange={(e) => setNewRow({ ...newRow, city: e.target.value })}
                placeholder="Город"
              />
              <input
                className={styles.input_DatabaseAdmin}
                value={newRow.region || ''}
                onChange={(e) => setNewRow({ ...newRow, region: e.target.value })}
                placeholder="Регион"
              />
            </>
          ) : selectedTable === 'Паблики' ? (
            <>
              <input
                className={styles.input_DatabaseAdmin}
                value={newRow.title || ''}
                onChange={(e) => setNewRow({ ...newRow, title: e.target.value })}
                placeholder="Название"
              />
              <input
                className={styles.input_DatabaseAdmin}
                value={newRow.group_id || ''}
                onChange={(e) => setNewRow({ ...newRow, group_id: e.target.value })}
                placeholder="Ссылка на группу"
              />
              <select
                className={styles.input_DatabaseAdmin}
                value={newRow.region_id || ''}
                onChange={(e) => setNewRow({ ...newRow, region_id: e.target.value })}
              >
                <option value="">Выберите регион</option>
                {regions.map(region => (
                  <option key={region.id} value={region.id}>
                    {region.city} - {region.region}
                  </option>
                ))}
              </select>
            </>
          ) : (
            <>
              <input
                className={styles.input_DatabaseAdmin}
                value={newRow.name || ''}
                onChange={(e) => setNewRow({ ...newRow, name: e.target.value })}
                placeholder="Название"
              />
              {selectedTable === 'Community' && (
                <input
                  className={styles.input_DatabaseAdmin}
                  value={newRow.group_id || ''}
                  onChange={(e) => setNewRow({ ...newRow, group_id: e.target.value })}
                  placeholder="ID группы"
                />
              )}
            </>
          )}
        </div>
        <div className={styles.footer_DatabaseAdmin}>
          <button className={styles.saveButton_DatabaseAdmin} onClick={onSave}>
            Сохранить
          </button>
          <button className={styles.cancelButton_DatabaseAdmin} onClick={onClose}>
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedTable: PropTypes.string.isRequired,
  newRow: PropTypes.object.isRequired,
  setNewRow: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default Modal;